import React, { useEffect, useState } from "react";
import "./ItemApprove.css";
import FilterModal from "./component/FilterModal";
import { Box, Button, Grid, useMediaQuery } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  ITEMSREQAConfirmSummaryAPI,
  summaryGridColumn,
} from "./ItemApproveRequestAction";
import { useDispatch, useSelector } from "react-redux";
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { Head_Set } from "./SliceItemApproveRequest";
import moment from "moment";
import ItemApprove_Breadcrumbs from "./ItemApprove_Breadcrumbs";
import { useNavigate } from "react-router-dom";

const ItemApproveSummary = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setShowOpen] = useState(false);
  const handleClose = () => setShowOpen(false);
  const status = [
    {
      value: "ALL",
      Name: "ALL",
    },
    {
      value: "ENTER",
      Name: "PENDING",
    },
    {
      value: "POST",
      Name: "COMPLETED",
    },
    {
      value: "REJECT",
      Name: "REJECTED",
    },
  ];

  const [summaryData, setSummaryData] = useState([]);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const filterObj = useSelector(
    (state) => state.SliceItemApproveRequest.value.filterObj
  );
  const LocWithoutRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );

  const itemRequestSummary = async () => {
    const Obj = {
      P_StartDate: moment(filterObj?.dateFrom).format("MM/DD/YYYY"),
      P_EndDate: moment(filterObj?.dateTo).format("MM/DD/YYYY"),
      P_Location:'',
      P_Status: filterObj?.status,
      P_UserCd: vRdxuserInfo.UserID,
    };
    let response = await ITEMSREQAConfirmSummaryAPI(
      fcheck_null_undefine_replace_empty(Obj)
    );
    if (response?.status === 200 && response?.data?.ResultSet?.length > 0) {
      let GridID = response?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSummaryData(GridID);
      handleClose();
    } else {
      handleClose();
      setSummaryData([]);
    }
  };

  const handleRowClick = (rowData) => {
    dispatch(
      Head_Set({
        A_Id: rowData.row.A_Id,
        A_Date: rowData.row.A_Date,
        A_Loc: rowData.row.A_Loc,
        A_LocName: rowData.row.A_LocName,
        A_Narr: rowData.row.A_Narr,
        A_Status: rowData.row.A_Status,
      })
    );
    navigate("/ItemApproveDetail");
    setTimeout(() => {
      document.getElementById("ApproveItemName")?.focus();
    }, 500);
  };

  useEffect(() => {
    itemRequestSummary();
  }, []);

  return (
    <div className=" my-3">
      <Grid container spacing={0}>
        <Grid item xs={9.8} sm={6} md={6} className="Breadcrumbs d-flex">
          <ItemApprove_Breadcrumbs />
        </Grid>
        <Grid
          item
          xs={2}
          sm={6}
          md={6}
          sx={{
            display: "flex",
            textAlign: vMediaQuery ? "" : "right",
            justifyContent: vMediaQuery ? "" : "right",
            gap: "8px",
          }}
        >
          <Button
            variant="contained"
            size={vMediaQuery ? "small" : "large"}
            sx={{
              textTransform: "capitalize",
              padding: vMediaQuery ? 0 : "8px 20px",
              height: vMediaQuery ? "25px" : "35px",
            }}
            onClick={() => {
              setShowOpen(true);
            }}
          >
            Filter
          </Button>
        </Grid>
      </Grid>

      <div className="ItemRequest-head pt-4">
        <Box style={{ height: "70vh", width: "100%" }}>
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            height={20}
            getRowId={(row) => row.id}
            rows={summaryData}
            columns={summaryGridColumn}
            experimentalFeatures={{ newEditingApi: false }}
            hideFooter={summaryData.length < 100}
            onRowClick={handleRowClick}
            components={{
              Toolbar: true ? "" : GridToolbar,
            }}
          />
        </Box>
      </div>

      <FilterModal
        open={open}
        handleClose={handleClose}
        status={status}
        LocWithoutRights={LocWithoutRights}
        filterObj={filterObj}
        vMediaQuery={vMediaQuery}
        itemRequestSummary={itemRequestSummary}
      />
    </div>
  );
};

export default ItemApproveSummary;
